'use client'

import type { TermineAccordionCamp } from '@/utilities/findCampsForTermineFilter'
import React from 'react'
import Link from 'next/link'
import { isFinishedCampStatus } from '@/utilities/campStatus'

export type TermineProps = {
  camps: TermineAccordionCamp[]
  centered?: boolean
  twoColumns?: boolean
}

const getButtonText = (camp: TermineAccordionCamp) => {
  if (isFinishedCampStatus(camp.campStatus)) return 'Camp vorbei'
  if (!camp.inPlanung && camp.campStatus === 'anmeldungGeschlossen') return 'Anmeldung geschlossen'
  if (camp.inPlanung || camp.campStatus === 'anmeldungGeschlossen') return 'Camp Details'
  if (camp.anmeldungAb && new Date(camp.anmeldungAb) > new Date()) {
    return 'Anmeldung in Kürze'
  } else if (camp.campStatus === 'anmeldungOffen') {
    return 'Jetzt anmelden'
  } else if (camp.campStatus === 'anmeldungInKurze') {
    return 'Anmeldung in Kürze'
  }
  return 'Camp Details'
}

export default function Termine({ camps, centered = false, twoColumns = false }: TermineProps) {
  if (camps.length === 0) {
    return (
      <div className="py-8 text-center">
        <div className="text-gray-600">Keine Termine für diese Kategorie verfügbar</div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div
        className={`space-y-4 pb-2 md:space-y-0 grid grid-cols-1 ${twoColumns ? 'md:grid-cols-2 gap-8' : ''}`}
      >
        {camps.map((camp) => (
          <div
            key={camp.id}
            className={`py-3 ${centered ? 'md:flex md:justify-between md:items-center' : 'md:grid md:grid-cols-12 md:items-center md:gap-4'} group`}
          >
            {camp.slug ? (
              <Link
                href={`/camps/${camp.slug}`}
                className="contents transition-colors duration-200 hover:bg-gray-50"
              >
                <div
                  className={`mb-2 ${centered ? 'md:mb-0 flex-1 text-left md:text-left' : 'md:col-span-6 md:mb-0'}`}
                >
                  <span className="font-medium">{camp.title}</span>
                </div>

                <div
                  className={`mb-2 ${centered ? 'md:mb-0 flex-1 text-left md:text-center' : 'md:col-span-3 md:mb-0'}`}
                >
                  <div className="text-sm md:text-base">
                    {camp.inPlanung ? (
                      <span className="text-gray-600">In Planung</span>
                    ) : camp.endDate ? (
                      <>
                        {new Date(camp.date).toLocaleDateString('de-DE', {
                          weekday: 'short',
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                        })}
                        <span className="text-sm"> - </span>
                        {new Date(camp.endDate).toLocaleDateString('de-DE', {
                          weekday: 'short',
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                        })}
                      </>
                    ) : (
                      new Date(camp.date).toLocaleDateString('de-DE', {
                        weekday: 'short',
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      })
                    )}
                  </div>
                </div>

                <div className={centered ? 'flex-1 text-left md:text-right' : 'md:col-span-3'}>
                  <span className="hover:underline group-hover:underline">
                    {getButtonText(camp)}
                  </span>
                </div>
              </Link>
            ) : (
              <>
                <div className={`mb-2 ${centered ? 'md:mb-0 flex-1' : 'md:col-span-6 md:mb-0'}`}>
                  <span className="font-medium">{camp.title}</span>
                </div>

                <div
                  className={`mb-2 ${centered ? 'md:mb-0 flex-1 text-left md:text-center' : 'md:col-span-3 md:mb-0'}`}
                >
                  <div className="text-sm md:text-base">
                    {camp.inPlanung ? (
                      <span className="text-gray-600">In Planung</span>
                    ) : camp.endDate ? (
                      <>
                        {new Date(camp.date).toLocaleDateString('de-DE', {
                          weekday: 'short',
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                        })}
                        <span className="text-sm"> - </span>
                        {new Date(camp.endDate).toLocaleDateString('de-DE', {
                          weekday: 'short',
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                        })}
                      </>
                    ) : (
                      new Date(camp.date).toLocaleDateString('de-DE', {
                        weekday: 'short',
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      })
                    )}
                  </div>
                </div>

                <div className={centered ? 'flex-1 text-left md:text-right' : 'md:col-span-3'}>
                  <span className="">Kein Link verfügbar</span>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
